import { render, staticRenderFns } from "./Verdict.vue?vue&type=template&id=62aada7c&scoped=true&"
import script from "./Verdict.vue?vue&type=script&lang=js&"
export * from "./Verdict.vue?vue&type=script&lang=js&"
import style0 from "./Verdict.vue?vue&type=style&index=0&id=62aada7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62aada7c",
  null
  
)

export default component.exports